import { render, staticRenderFns } from "./page_list.vue?vue&type=template&id=78c6ce20&scoped=true&"
import script from "./page_list.vue?vue&type=script&lang=js&"
export * from "./page_list.vue?vue&type=script&lang=js&"
import style0 from "./page_list.vue?vue&type=style&index=0&id=78c6ce20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6ce20",
  null
  
)

export default component.exports